import styled from "styled-components";

let PageWrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  padding-top: 1em;
  //margin: 3em auto auto auto;
  //display: flex;
  font-size: 12pt;
  height: 100%;
`;

let InnerWrapper = styled.div`
  //display: flex;
  //  flex-direction: column;
  //  justify-content: flex-start;
  width: 100%;
  height: 100%;
  //padding: 1em;
  background-color: white;
  border-radius: 5px;
  margin: 0em auto;
`;

export { PageWrapper, InnerWrapper };
